import { lazy } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppLayout } from '@/components/layout/app-layout';
import { AuthLayout } from '@/components/layout/auth-layout';
import { ProtectedRoute } from '@/features/auth/components/protected-route';
import { LazyPage } from './lazy-page';

const LoginPage = lazy(() => import('@/features/auth/pages/login-page'));
const DashboardPage = lazy(() => import('@/features/dashboard/pages/dashboard-page'));
const ClientsListPage = lazy(() => import('@/features/clients/pages/clients-list-page'));
const ClientDetailPage = lazy(() => import('@/features/clients/pages/client-detail-page'));
const ClientFormPage = lazy(() => import('@/features/clients/pages/client-form-page'));
const TreatmentsPage = lazy(() => import('@/features/treatments/pages/treatments-page'));
const TreatmentFormPage = lazy(() => import('@/features/treatments/pages/treatment-form-page'));
const TherapistsListPage = lazy(() => import('@/features/therapists/pages/therapists-list-page'));
const TherapistFormPage = lazy(() => import('@/features/therapists/pages/therapist-form-page'));
const TherapistDetailPage = lazy(() => import('@/features/therapists/pages/therapist-detail-page'));
const AgendaPage = lazy(() => import('@/features/agenda/pages/agenda-page'));
const AppointmentsListPage = lazy(() => import('@/features/appointments/pages/appointments-list-page'));
const PaymentsListPage = lazy(() => import('@/features/payments/pages/payments-list-page'));
const ReportsPage = lazy(() => import('@/features/reports/pages/reports-page'));
const MarketingPage = lazy(() => import('@/features/marketing/pages/marketing-page'));
const SettingsPage = lazy(() => import('@/features/settings/pages/settings-page'));

const lazyRoute = (element: React.ReactNode) => <LazyPage>{element}</LazyPage>;

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <AuthLayout>{lazyRoute(<LoginPage />)}</AuthLayout>,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: lazyRoute(<DashboardPage />) },
      { path: 'clients', element: lazyRoute(<ClientsListPage />) },
      { path: 'clients/new', element: lazyRoute(<ClientFormPage />) },
      { path: 'clients/:id', element: lazyRoute(<ClientDetailPage />) },
      { path: 'clients/:id/edit', element: lazyRoute(<ClientFormPage />) },
      { path: 'treatments', element: lazyRoute(<TreatmentsPage />) },
      { path: 'treatments/new', element: lazyRoute(<TreatmentFormPage />) },
      { path: 'treatments/:id/edit', element: lazyRoute(<TreatmentFormPage />) },
      { path: 'therapists', element: lazyRoute(<TherapistsListPage />) },
      { path: 'therapists/new', element: lazyRoute(<TherapistFormPage />) },
      { path: 'therapists/:id', element: lazyRoute(<TherapistDetailPage />) },
      { path: 'agenda', element: lazyRoute(<AgendaPage />) },
      { path: 'appointments', element: lazyRoute(<AppointmentsListPage />) },
      { path: 'payments', element: lazyRoute(<PaymentsListPage />) },
      { path: 'reports', element: lazyRoute(<ReportsPage />) },
      { path: 'marketing', element: lazyRoute(<MarketingPage />) },
      { path: 'settings', element: lazyRoute(<SettingsPage />) },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
